module.exports = __webpack_public_path__ + "img/tent.1f5afba2.svg";